"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageOperationSpecification = void 0;
var destination_1 = require("./destination");
var ImageOperationSpecification = /** @class */ (function () {
    function ImageOperationSpecification(data) {
        this.command = null;
        this.destination = null;
        this.command = data.command;
        this.destination = new destination_1.Destination(data.destination);
    }
    return ImageOperationSpecification;
}());
exports.ImageOperationSpecification = ImageOperationSpecification;
//# sourceMappingURL=image-operation-specification.js.map